import Close from '@mui/icons-material/Close';
import { Box, Container, IconButton, Modal, Typography } from '@mui/material';

export default function RewardInfoModal({ open, handleClose }) {
    return (
        <Modal
            open={open}
            onClose={handleClose}
        >
            <Container maxWidth={'xs'} className="reward-modal-container">
                <Box className="cross-container" >
                    <IconButton onClick={handleClose}>
                        <Close />
                    </IconButton>
                </Box>
                <Typography variant="body2" sx={{ mb: 3 }}>
                    For any pending claims, keep an eye on your email inbox for a message from our iCare team with the suggested date and time for picking up your reward(s). Once you receive it, you can head over to the SGFIN office to collect your rewards.
                    <br />
                    <br />
                    If you have any questions or concerns, feel free to reach out to us at <a href={`mailto:${process.env.REACT_APP_HELP_EMAIL}`}>{process.env.REACT_APP_HELP_EMAIL}</a>
                </Typography>
            </Container>
        </Modal>
    );
}
